// extracted by mini-css-extract-plugin
export default {"questionResultsPage_h1":"QuestionResultsPage_questionResultsPage_h1__Ofbj+","questionResultsPage_underline":"QuestionResultsPage_questionResultsPage_underline__KDbR7"};